import React, { useState } from 'react';
import '../../css/promocion.css'
import promo3 from '../../assets/images/promociones/banner_bf_navidad.jpg'
import lateralPromo1 from '../../assets/images/promociones/promo-ninos.png'
import lateralPromo2 from '../../assets/images/promociones/adulto-mayor.png'
import { Outlet, Link } from "react-router-dom";
import whatsapp from '../../assets/images/chat.svg'
import formulario from '../../assets/images/formulario-de-contacto.svg'
import mapa from '../../assets/images/mapa.svg'
import Footer from '../../components/Footer'
import { useTranslation } from 'react-i18next';


export default function Promo10() {
    const [copied, setCopied] = useState(false);  
    const promoCode = 'FLASH25BF';  
    const { t } = useTranslation('promo10');

    const copyToClipboard = async () => {
        try {
          await navigator.clipboard.writeText(promoCode);
          setCopied(true);
          setTimeout(() => setCopied(false), 2000); // Oculta el mensaje después de 2 seg
        } catch (err) {
          console.error('Error al copiar el código:', err);
        }
      };

  return (
   <>

    <section>
        <div className='header_section'>
            <div className='container header_section_box'>
                <div className='header_section_title'>
                    <h3>Promociones para viajar</h3>
                    <p>Cada viaje guarda una historia…</p>
                </div>                
            </div>
        </div>
    </section>   
    <section className='container'>
        <div className='banner-header-promo'>
            <img src={promo3} alt='promo semana santa' />
        </div>
    </section>

    <section className='sectionPromo_content'>
        <div className='container'>
            <div className='box_promo'>
                <div className='content_text_promo'>
                    <div className='content_promo'>

                        
                        <p>¿Tienes una foto que lo dice todo?</p>
                        <p>Es momento de sacarla de tu galería y compartir esa travesía inolvidable con <strong>Baja Ferries</strong>.</p>
                        <p>¡Tu experiencia podría convertirse en tu próximo viaje!</p>
                        
                        <h3> ¿Cómo participar?</h3>

                       
                        <ul>
                            <li>1. Comparte tu foto más memorable viajando con <strong>Baja Ferries</strong> en los comentarios del post oficial de la dinámica (Facebook)</li>
                            <li>2. Acompáñala con una breve historia sobre esa travesía (a quién visitaste, qué significó, etc.).</li>
                            <li>3. Invita a tus amigos y contactos a reaccionar (like) a tu comentario.</li>                            
                        </ul>
                        <p>Las fotos con más likes serán las ganadoras.</p>

                        <h4>Premios</h4>
                        
                        <ul>
                            <li>1er lugar: Viaje redondo con cabina para 2 personas.</li>
                            <li>2do lugar: Viaje redondo en salón VIP o Ejecutivo para 2 personas.</li>
                            <li>3er lugar: Viaje redondo para 2 personas.</li>
                        </ul>
                        <br />

                        <label>¡Los 3 ganadores serán anunciados en las redes sociales oficiales de Baja Ferries el 6 de enero de 2026!</label>
                        
                        <div className='content_promo_btn'>                                                
                            <a className='cta_promo' href="tel:8003377437" rel="noopener noreferrer"><span >{t('btn1')} </span></a> 
                            <a target="_blank" className='cta_promo' rel='noopener noreferrer' href='https://wa.me/5218003377437?text=Me%20interesa%20una%20cotización'>{t('btn2')}  </a>
                        </div> 
                    </div>

                  {/*}  <p className='promotion-code-title'>{t('codigo')}:</p>
                    <div className='promotion-code' onClick={copyToClipboard}>
                        {promoCode}
                    </div>

                    <span className="text-sm text-green-600 h-4">
                        {copied ? '¡Código copiado!' : ''}
                    </span>*/}
                                    
                    <div className='content_promo condiciones-promo'>
                         <h4>Términos y condiciones</h4>                    
                        <ul>                                                        
                            <li>• Vigencia de la dinámica: Del 16 de diciembre de 2025 al 2 de enero de 2026.</li> 
                            <li>• Válido solo para personas mayores de 18 años.</li>
                            <li>• Premios válidos durante todo el año 2026.</li>
                            <li>• Sujeto a disponibilidad.</li>
                            <li>• El premio no es canjeable por dinero en efectivo ni transferible a otra persona.</li>
                            <li>• En caso de empate en likes, se considerará la fecha/hora del comentario como criterio de desempate.</li>
                            <li>• Las historias y fotos seleccionadas podrán ser utilizadas por Baja Ferries en redes sociales, sitio web y piezas promocionales, dando el debido crédito al autor.</li>
                            <li>• La participación en esta dinámica implica la aceptación total de estas bases y condiciones.</li>                                                   
                        </ul>
                    </div>
                    {/*<div className='content_promo btn-termino-condiciones'>
                    <Link to="/condiciones-de-servicio">Consulta términos y condiciones</Link> 
                    </div>*/}
                </div>
                <div className='content_contador_promo'>

                    <div className='content_promo'>
                        {/*}
                        <div className='content-isotipo'>
                            <img src={bfIso} alt='bf-isotipo'/>
                        </div>
                        <div>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                                quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
                                consequat.
                            </p>

                        </div>
                        <div>
                            <Temporizador targetDate={targetDate} />
                        </div>
                        */}
                        <h4>{t('text6')} </h4>
                        <div className='lateral-promo'>
                            <Link to="/promo-ninos">
                                <img src={lateralPromo1} alt='buen-fin-bajaferries' />
                            </Link> 
                        </div>
                        <div className='lateral-promo'>
                            <Link to="/promo-adulto-mayor">
                                <img src={lateralPromo2} alt='buen-fin-bajaferries' />
                            </Link> 
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>        
    </section>
    
    <section className="callToAction">
        <div className='container'>
            <div>
                <h3> </h3>
            </div>
            <div className='callToAction_row'>
                <div className='callToAction_container'>
                    <div className='callToAction_icon'>
                        <img src={formulario} alt="bookingIcon" className='bookingIcon' />
                    </div>
                    <div className='callToAction_content'>
                        <div className='callToAction_box'>
                            <div>
                                <h4>{t('cta1_title1')}</h4>
                            </div>
                            <div>
                                <p>{t('cta_title1')} </p>
                            </div>
                        </div>
                        <div className='callToAction_box'>
                            
                            <a href="tel:8003377437" target="_blank" rel="noopener noreferrer">{t('cta_btn1')}  </a>  
                           
                        </div>
                    </div>
                </div>
                <div className='callToAction_container'>
                    <div className='callToAction_icon'>
                        <img src={mapa} alt="bookingIcon" className='bookingIcon' />
                    </div>
                    <div className='callToAction_content'>
                        <div className='callToAction_box'>
                            <div>
                                <h4>{t('cta1_title2')}</h4>
                            </div>
                            <div>
                                <p>{t('cta_title2')}</p>
                            </div>
                        </div>
                        <div className='callToAction_box'>
                            <Link to="/antes-de-viajar">{t('cta_btn2')}  </Link>     
                        </div>
                    </div>
                </div>
                <div className='callToAction_container'>
                    <div className='callToAction_icon'>
                        <img src={whatsapp} alt="bookingIcon" className='bookingIcon' />
                    </div>
                    <div className='callToAction_content'>
                        <div className='callToAction_box'>
                            <div>
                                <h4>{t('cta1_title3')}</h4>
                            </div>
                            <div>
                                <p>{t('cta_title3')} </p>
                            </div>
                        </div>
                        <div className='callToAction_box'>
                            <Link to="/tarifas">{t('cta_btn3')}</Link>                     
                        </div>
                    </div>
                </div>
            </div>

        </div>
   </section>

        <Outlet />

    <Footer />
   
   </>
  )
}
